import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
// reactstrap components
import { Container, Spinner } from 'reactstrap';
// core components
import AdminNavbar from '../components/Navbars/AdminNavbar.js';
import Sidebar from '../components/Sidebar/Sidebar.js';
import { usePaginationCounts } from '../utils/queries/hostQueries.js';
import { useWhoAmI } from 'utils/queries/profileQueries';
import { routes, corporateAdminRoutes } from '../routes';
import CorporateChargers from 'views/Corporates/CorporateChargers.js';
import CorporateChargingSessions from 'views/Corporates/CorporateChargingSessions.js';
import CorporateUsers from 'views/Corporates/CorporateUsers.js';
import CorporateCharger from 'views/Corporates/CorporateCharger.js';
import CorporateDetails from 'views/Corporates/CorporateDetails.js';
import SessionDetails from 'components/Corporates/SessionDetails/index.js';
import CorporateUsersChargingSession from 'views/Corporates/CorporateUserChargingSessions.js';

const CorporateAdmin = (props) => {
  const mainContent = React.useRef(null);

  usePaginationCounts();

  const { data: accountInfo, isLoading: isLoadingProfile } = useWhoAmI();

  const getRoutes = () =>
    accountInfo?.user?.IS_CORPORATE_ADMIN ? corporateAdminRoutes : routes;

  return (
    <>
      <Sidebar
        {...props}
        routes={getRoutes()}
        logo={{
          innerLink: '/admin/index',
          imgSrc: require('../assets/companyLogo/jplogo.png').default,
          imgAlt: '...',
        }}
      />

      <div
        className="main-content"
        ref={mainContent}
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        {isLoadingProfile ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              minHeight: '100vh',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Spinner style={{ color: '#2675b8' }} />
          </div>
        ) : (
          <>
            <AdminNavbar accountInfo={accountInfo} brandText="Joulepoint" />
            <Container fluid style={{ marginLeft: 10, marginTop: 80 }}>
              <Switch>
                <Route path="/corporate/plans" exact>
                  <CorporateDetails corporateId="" />
                </Route>
                <Route path="/corporate/chargers">
                  <CorporateChargers />
                </Route>
                <Route
                  path="/corporate/charger/detail/:corporateId/:chargerId/:chargerMapId"
                  render={({ match: thisMatch }) => (
                    <CorporateCharger
                      corporateId={thisMatch.params?.corporateId}
                      cpid={thisMatch.params?.chargerId}
                      chargerMapId={thisMatch.params?.chargerMapId}
                    />
                  )}
                />
                <Route path="/corporate/sessions" exact>
                  <CorporateChargingSessions />
                </Route>
                <Route
                  path="/corporate/session/:qid"
                  render={({ match: thisMatch }) => (
                    <SessionDetails qId={thisMatch.params?.qid} />
                  )}
                />
                <Route path="/corporate/users" exact>
                  <CorporateUsers />
                </Route>
                <Route
                  path="/corporate/users/session/:userId/:email/:phone"
                  render={({ match: thisMatch }) => (
                    <CorporateUsersChargingSession
                      phone={thisMatch.params?.phone}
                      userId={thisMatch.params?.userId}
                      email={thisMatch.params?.email}
                    />
                  )}
                />
                <Redirect from="*" to="/admin/index" />
              </Switch>
            </Container>
            <Container
              fluid
              style={{ marginTop: 'auto', height: '40px' }}
            ></Container>
          </>
        )}
      </div>
    </>
  );
};

export default CorporateAdmin;
